import React from "react";
import ReactDOM from "react-dom";
import { getAnalytics } from "firebase/analytics";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import firebaseConfig from "./utils/FirebaseConfig";

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById("root")
);

// Initialize Firebase
const app = firebaseConfig;
const analytics = getAnalytics(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
